"use client";

import Link from "next/link";
import { Suspense } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { AuthCard } from "@/components/auth/AuthCard";
import { signInWithEmail } from "@/lib/auth/browser";
import { safeAuthNext } from "@/lib/auth/redirect";

function LoginInner() {
  const router = useRouter();
  const params = useSearchParams();
  // Only same-origin relative paths — never a full URL (open-redirect guard).
  const next = safeAuthNext(params.get("next"));

  return (
    <AuthCard
      title="Sign in"
      cta="Sign in"
      onSubmit={async (email, password) => {
        await signInWithEmail({ email, password });
        router.push(next);
      }}
      footer={
        <>
          No account?{" "}
          <Link
            href={`/signup?next=${encodeURIComponent(next)}`}
            className="text-white underline-offset-4 hover:underline"
          >
            Sign up
          </Link>
        </>
      }
    />
  );
}

export default function LoginPage() {
  return (
    <Suspense>
      <LoginInner />
    </Suspense>
  );
}
